import React from "react";

export default function Inperson({ fill, width, height }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99935 2.6665C8.70659 2.6665 9.38487 2.94746 9.88497 3.44755C10.3851 3.94765 10.666 4.62593 10.666 5.33317C10.666 6.04041 10.3851 6.71869 9.88497 7.21879C9.38487 7.71889 8.70659 7.99984 7.99935 7.99984C7.2921 7.99984 6.61383 7.71889 6.11373 7.21879C5.61363 6.71869 5.33268 6.04041 5.33268 5.33317C5.33268 4.62593 5.61363 3.94765 6.11373 3.44755C6.61383 2.94746 7.2921 2.6665 7.99935 2.6665ZM7.99935 9.33317C10.946 9.33317 13.3327 10.5265 13.3327 11.9998V13.3332H2.66602V11.9998C2.66602 10.5265 5.05268 9.33317 7.99935 9.33317Z"
        fill={fill}
      />
    </svg>
  );
}
